import axios from 'axios'

export function fetchVehicles(data) {
  return axios.get('/vehicles', {
    params: Object.assign({ rowsPerPage: 9999 }, data),
  })
}

export function fetchVehicleTypes(data) {
  return axios.get('/vehicle-types', {
    params: Object.assign({ rowsPerPage: 9999 }, data),
  })
}

export function fetchVehicle(id) {
  return axios.get('/vehicles/' + id)
}
